export const formData = {
    rfc:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
          id:'rfc',
          type:'text',
          fullWidth: true,
        },
        rules:{
        type:'rfc',
        }
    },
    user:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
            id:'user',
            type:'text',
            fullWidth: true,
        },
        rules:{
            type:'distance',
            min:1,
            max:100
        }
    },
    password:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
            id:'password',
            type:'text',
            fullWidth: true,
        },
        rules:{
            type:'distance',
            min:1,
            max:100
        }
    }
};
